// import logo from './logo.jpeg';
import './App.css';

function App() {
 return (
    <div style={{ fontFamily: "Georgia, serif" }}>
      {/* HERO SECTION */}
      <section
        style={{
          height: "90vh",
          backgroundImage:
            "url('https://lh3.googleusercontent.com/gps-cs-s/AHVAweo-6GyCx8FKRsWjSDohXAxWVPdIgDWJN3LJMKKLzEtx-py_QFbxWlHuq0aTqhim59c5iT3nqoTmj9T7HZ4qZ7RuX6YEuR9EUAZfclaTfuF49RgwUzoZ8TIGbNQEZ3BEOTut30z4MNM6VOsP=s1360-w1360-h1020-rw')",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          position: "relative",
          color: "white",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
          }}
        ></div>

        {/* Cafe Name */}
        {/* <div
          style={{
            position: "absolute",
            top: "25px",
            width: "100%",
            textAlign: "center",
            letterSpacing: "6px",
            fontSize: "24px",
            fontWeight: "500",
            zIndex: 2,
          }}
        >
          CHURI CHASKA CAFE
        </div> */}

        {/* Hero Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            textAlign: "center",
            zIndex: 2,
          }}
        >
          {/* <h1
            style={{
              fontSize: "70px",
              fontWeight: "400",
              margin: 0,
            }}
          >
            Sip, Savor, Smile!
          </h1> */}
        </div>
      </section>

      {/* CONTACT US SECTION */}

      <section
        style={{
          background: "#050505",
          color: "#cfcfcf",
          textAlign: "center",
          padding: "10px 20px",
        }}
      >
        <h2
          style={{
            fontSize: "48px",
            fontWeight: "400",
            marginBottom: "10px",
          }}
        >
          Contact Us
        </h2>

        <div
          style={{
            width: "60px",
            height: "2px",
            background: "#666",
            margin: "20px auto",
          }}
        ></div>

        <p>Email : singhgurmajor543@gmail.com</p>
        <p>Phone : +91 77107 61398</p>
        <p>Location : The Empire Gedi Route, Rajpura-Patiala rd, 
                      Multanpur, Patiala, Rajpura, Punjab 140701</p>
      </section>
    </div>
  );
}

export default App;